import { useState } from 'react'
import { Copy, Check, X, KeyRound } from 'lucide-react'

export default function TokenRevealModal({ token, onClose }: { token: string; onClose: () => void }) {
  const [copied, setCopied] = useState(false)
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(token)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch { /* clipboard blocked - user can select manually */ }
  }
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60" onClick={onClose}>
      <div className="bg-card rounded-xl shadow-2xl w-[460px] max-w-[95vw]" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-border">
          <h3 className="text-foreground font-semibold flex items-center gap-2"><KeyRound size={16} /> Your new API key</h3>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground"><X size={18} /></button>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-sm text-muted-foreground">
            Copy it now - for security we only show it once. If you lose it, revoke the key and create a new one.
          </p>
          <div className="flex items-stretch gap-2">
            <code className="flex-1 bg-muted rounded px-3 py-2 text-xs text-foreground break-all font-mono">{token}</code>
            <button onClick={copy} className="shrink-0 inline-flex items-center gap-1.5 px-3 py-2 text-sm bg-primary text-primary-foreground rounded-md">
              {copied ? <Check size={14} /> : <Copy size={14} />}{copied ? 'Copied' : 'Copy'}
            </button>
          </div>
        </div>
        <div className="flex justify-end px-5 py-3 border-t border-border">
          <button onClick={onClose} className="px-4 py-2 text-sm bg-muted text-foreground rounded-md hover:bg-accent">Done</button>
        </div>
      </div>
    </div>
  )
}
